/**
 * Builds a product ID from a colon-delimited enterprise SKU.
 * @param sku - Enterprise SKU in `<brand>:<style>:<color>:...` format.
 * @param options - Product ID formatting options.
 * @param options.includeColor - Include the SKU color segment in the product ID.
 * @returns The formatted product ID, or `undefined` when the SKU is incomplete.
 * @category Utils
 */
export const getProductIdFromSku = (
  sku: string | undefined,
  { includeColor = false }: { includeColor?: boolean } = {}
): string | undefined => {
  const [brand, style, color] = sku?.split(':') || []

  if (!brand || !style || (includeColor && !color)) return

  return `${brand}${style}${includeColor ? color : ''}`
}
